var ANALYTICS_SDK_LOADED = new Promise(function (resolve) {
    if ("adobeAnalytics" in window) {
        resolve();
    }
    else {
        waitFor("ANALYTICS_SDK_LOADED").then(resolve);
    }
});
var S_CODE_READY = waitFor("S_CODE_READY");
var ON_TRACKING_READY = ANALYTICS_SDK_LOADED.then(function () { return S_CODE_READY; });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var isTrackingReady = false;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
ON_TRACKING_READY.then(function () { return (isTrackingReady = true); });
export function init(data) {
    window.wa_data = data;
    ANALYTICS_SDK_LOADED.then(function () {
        window.adobeAnalytics.init(window.wa_data);
    });
}
export function triggerOptIn() {
    window.adobeAnalytics.triggerOptIn();
}
export function trackPage(obj) {
    window.wa_data.siteSection = obj.siteSection;
    // window.wa_data.siteSubSection = obj.siteSubSection;
    window.wa_data.pageName = obj.pageName;
    var event = {
        pageName: window.wa_data.pageName,
        pageUrl: obj.pageUrl,
        siteName: window.wa_data.siteName,
        siteSection: window.wa_data.siteSection,
        siteSubSection: window.wa_data.siteSubSection,
        ubisoftId: window.wa_data.ubisoftId,
        mdmBrandId: window.wa_data.mdmBrandId,
        mdmInstallmentId: window.wa_data.mdmInstallmentId,
        installmentName: window.wa_data.installmentName,
        brandName: window.wa_data.brandName,
        productId: window.wa_data.mdmBrandId,
    };
    ON_TRACKING_READY.then(function () { return window.adobeAnalytics.track("pageevent", event); });
}
export function trackClick(obj) {
    ON_TRACKING_READY.then(function () { return window.adobeAnalytics.track("clickevent", obj); });
}
export function trackImpression(obj) {
    ON_TRACKING_READY.then(function () {
        return window.adobeAnalytics.track("impressionevent", obj);
    });
}
export function trackAccount(obj) {
    ON_TRACKING_READY.then(function () {
        window.wa_data.ubisoftId = obj.ubisoftId || "";
        window.adobeAnalytics.track("accountevent", obj);
    });
}
function waitFor(event) {
    return new Promise(function (resolve) {
        function listener(e) {
            if (e.data === event) {
                window.removeEventListener("message", listener);
                resolve();
            }
        }
        window.addEventListener("message", listener);
    });
}
export function displayPrivacySettings() {
    window.adobeAnalytics.displayPrivacySettings();
}
export function getInstallmentName() {
    return window.wa_data.installmentName || "";
}
